module.exports = __webpack_public_path__ + "img/finance-on.1a95281e.svg";